import { GetSelectable } from "event-definitions"

export function getSelectables() {
    const { selected } = GetSelectable.call({ selected: {} })
    return selected
}
